<template>
  <Layout>
    <el-tabs v-model="activeTab" class="login-tabs" @tab-click="handleTabChange">
      <el-tab-pane label="账号登录" name="password">
      </el-tab-pane>
      <el-tab-pane label="验证码登录" name="smscode">
      </el-tab-pane>
      <el-form
        :model="form"
        :rules="rules"
        ref="form">
        <template v-if="activeTab === 'password'">
          <el-form-item prop="companyName">
            <el-input
              v-model="form.companyName"
              @keyup.enter.native="primaryBtnClick"
              @input="clearPhoneCode"
              prefix-icon="el-icon-office-building"
              placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item prop="userName">
            <el-input
              v-model="form.userName"
              @keyup.enter.native="primaryBtnClick"
              @input="clearPhoneCode"
              prefix-icon="el-icon-user"
              placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              @keyup.enter.native="primaryBtnClick"
              @input="clearPhoneCode"
              show-password
              prefix-icon="el-icon-lock"
              placeholder="请输入密码"></el-input>
          </el-form-item>
        </template>
        <template v-else-if="activeTab === 'smscode'">
          <el-form-item prop="phone">
            <el-input
              v-model="form.phone"
              @keyup.enter.native="primaryBtnClick"
              @input="clearPhoneCode"
              prefix-icon="el-icon-mobile-phone"
              placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item prop="verifyCode">
            <el-input
              v-model="form.verifyCode"
              @keyup.enter.native="primaryBtnClick"
              @input="clearPhoneCode"
              style="width: 200px;vertical-align: middle;"
              maxlength="6"
              placeholder="填写验证码">
              <span class="el-input__icon" slot="prefix" style="display: inline-block;line-height: 45px;">
                <img src="@/assets/images/verify_code.png" width="16px" height="16px"  />
              </span>
            </el-input>
            <el-button
              style="width: 128px; height: 40px;vertical-align: middle;margin-left: 12px;"
              @click="getPhoneLoginVerifyCode" :disabled="!!getPhoneVerifyCodeTimmer">
              {{ getPhoneVerifyCodeBtnText }}
            </el-button>
          </el-form-item>
        </template>
        <template v-if="needValiCodePic">
          <el-form-item prop="validationCode">
            <div class="valicode-row">
              <el-input
                v-model="form.validationCode"
                @keyup.enter.native="primaryBtnClick"
                class="valicode-input"
                placeholder="验证码" />
              <div class="valicode-pic">
                <img :src="byteImg" />
              </div>
              <div class="valicode-btn">
                看不清楚?<el-button @click="getValiCodePic" class="link" type="link">换一张</el-button>
              </div>
            </div>
          </el-form-item>
        </template>
        <template v-if="needPhoneVerifyCode">
          <div v-if="!!phoneCodeMsg" class="phoneCodeMsg">{{phoneCodeMsg}}</div>
          <el-form-item>
            <div class="valicode-row">
              <el-input
                v-model="phoneVerifyCode"
                style="width: 240px"
                @keyup.enter.native="primaryBtnClick"
                class="valicode-input"
                placeholder="验证码" />
              <el-button
                style="width: 88px; height: 40px;"
                @click="getPhoneVerifyCode" :disabled="!!getPhoneVerifyCodeTimmer">
                {{ getPhoneVerifyCodeBtnText }}
              </el-button>
            </div>
          </el-form-item>
          <div v-if="!!phoneVerifyCodePhoneNum" class="phoneCodeTip">
            验证码已发送至{{ phoneVerifyCodePhoneNum }}
          </div>
          <div v-if="phoneVerifyCodeError" class="phoneCodeTipError">
            {{ errorMsg }}
          </div>
        </template>
        <el-form-item>
          <el-checkbox v-model="form.agreement" label="我已阅读并同意"></el-checkbox>
          <a style="font-size: 12px;" href="https://erp-qd.oss-cn-hangzhou.aliyuncs.com/erp-kmt/%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE_%E5%BF%AB%E9%BA%A6ERP%E8%BD%AF%E4%BB%B6_20240325.pdf" target="_blank">《用户协议》</a>
          <a style="font-size: 12px;" href="https://erp-qd.oss-cn-hangzhou.aliyuncs.com/erp-kmt/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96_%E5%BF%AB%E9%BA%A6ERP%E8%BD%AF%E4%BB%B6_20240326.pdf" target="_blank">《隐私政策》</a>
        </el-form-item>
        <el-form-item
          class="mt-16">
          <PrimaryBtn
            :disabled="primaryBtnDisabled"
            @click="primaryBtnClick">
            {{isLoging ? '登录中' : '立即登录'}}
          </PrimaryBtn>
        </el-form-item>
      </el-form>
    </el-tabs>
    <div class="footer">
      <div v-if="activeTab === 'password'" class="item-side">
        <el-button class="link" type="link" :underline="false" @click="$router.push({name: 'l_forgetPassowrd'})">忘记密码</el-button>
      </div>
      <div class="item-side">
        没有账号？<el-button class="link" type="link" :underline="false" @click="$router.push({name: 'l_register'})">免费注册</el-button>
      </div>
    </div>
    <Protocol ref="protocol"></Protocol>
  </Layout>
</template>

<script>
import Layout from '../components/LoginLayout'
import PrimaryBtn from '../components/LoginPrimaryBtn'
import Protocol from '../components/Protocol'
import {loginServer, getValiCodePicSrc, loadUserInfo, phoneCodeGet, phoneLoginCodeGet, switchIdentity} from '../servers.js'
import { getCompanyInfo } from '@/api/login-api.js'
import { validPhone, regPhone } from './validate.js';
import { autoJump } from '@/pre-init';

export default {
  components: {
    Layout,
    PrimaryBtn,
    Protocol
  },
  data() {
    return {
      activeTab: 'password',
      validationCode: '',
      phoneVerifyCode: '',
      form: {
        companyName: '测试分销商LR1',
        password: 'haobai123@WZ',
        userName: 'haobai',
        phone: '',
        verifyCode: '',
        agreement: false
      },
      rules: {
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入登录密码', trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入登录账户', trigger: 'blur'}
        ],
        validationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
        phone: [{ required: true, validator: validPhone, trigger: 'blur' }],
        verifyCode: [
          {required: true, message: '请输入短信验证码', trigger: 'blur'}
        ],
      },
      needValiCodePic: false,
      byteImg: '',
      isLoging: false,
      grayList: [],
      needPhoneVerifyCode: false,
      getPhoneVerifyCodeTimmer: null,
      getPhoneVerifyCodeCD: 60,
      phoneVerifyCodePhoneNum: '',
      phoneCodeMsg: '',
      phoneVerifyCodeError: false,
      errorMsg: '验证码错误，请重新输入'
    }
  },
  watch: {
    needValiCodePic(val) {
      if (val) {
        this.$set(this.form, 'validationCode', '')
        this.getValiCodePic()
      } else {
        this.$delete(this.form, 'validationCode')
      }
    }
  },
  computed: {
    primaryBtnDisabled() {
      return this.isLoging
    },
    getPhoneVerifyCodeBtnText() {
      if (!this.getPhoneVerifyCodeTimmer) {
        return '获取验证码'
      }
      return `(${this.getPhoneVerifyCodeCD < 10 ? '0' : ''}${this.getPhoneVerifyCodeCD})s`
    }
  },
  methods: {
    async primaryBtnClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.agreement) {
            this.$refs.protocol.open(() => {
              this.form.agreement = true
              this.primaryBtnClick()
            })
            return
          }
          this.login();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async login() {
      // 不同域名，转到邀请分享的链接
      let share_location = sessionStorage.getItem('_share_location_');

      try {
        let data = {
          ...this.form,
          password: this.$utils.login.encodePwd(this.form.password)
        }
        let loginUrl = '/account/login'
        if (this.activeTab === 'smscode') {
          const { phone, verifyCode } = this.form;
          data = {
            phone,
            phoneVerifyCode: verifyCode
          }
          loginUrl = '/account/loginPhoneCode';
        } else {
          delete data['phone'];
          delete data['verifyCode']
        }
        if(share_location){
          data.pathUrl = JSON.parse(share_location);
        }
        if (this.needPhoneVerifyCode) {
          data.phoneVerifyCode = this.phoneVerifyCode
        }
        this.isLoging = true

        const res = await loginServer(data, loginUrl)
        if (typeof res === 'string') {
          !(/\/verify.html/.test(res) || /\/mobile.html/.test(res)) && this.$message.error(res)
          this.isLoging = false
          return;
        } else if (res._code === -1) {
          this.$message.error(res.msg)
          if (!this.needValiCodePic) {
            this.needValiCodePic = true
          } else {
            this.getValiCodePic()
          }
          this.isLoging = false
          return;
        } else if ([-2, -3].includes(res._code)) {
          this.isLoging = false;
          this.loginVerifyFlow(res);
          return;
        } else if (!res){
          this.isLoging = false
          return;
        }
        await this.loadUserInfo2Jump();
        this.isLoging = false
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoging = false
      }
    },
    // 检验当前登录身份与要跳转的邀请链接是否符合，否则需要调用身份切换接口，然后重新走loadUserInfo2Jump方法
    async checkBindRelationUrlJump(bindRelationUrl, loginIdentity) {

      // 邀请供销商 且登录者是供销商
      // 邀请分销商 且登录者是分销商
      // 就正常跳转
      // 否则需要切换身份后，重新走loadUserInfo2Jump方法
      const isTrue =
        (/^\/supplier\/management\/mine/.test(bindRelationUrl) && loginIdentity === 1) ||
        (/^\/distributor\/supplier\/mine/.test(bindRelationUrl) && loginIdentity === 2) || 
        (/^\/supplier\/dangkou\/shipment/.test(bindRelationUrl) && loginIdentity === 1)|| 
        (/^\/supplier\/dangkou\/shipment\/detail/.test(bindRelationUrl) && loginIdentity === 1);;
      if (isTrue) {
        this.$router.push(bindRelationUrl)
      } else {
        // 切换身份
        const success = await switchIdentity(loginIdentity === 1 ? 2 : 1);
        if (success) {
          this.loadUserInfo2Jump()
        }
      }
    },
    async loadUserInfo2Jump() {
      const success = await loadUserInfo()
      const bindRelationUrl = this.$store.getters.bindRelationUrl;
      if (success) {
        let share_location = sessionStorage.getItem('_share_location_');
        
        // PH-AI 注册版本默认进入分销商身份
        const ciRes = await getCompanyInfo();
        const isPHAI = ciRes && ciRes.versionNumber === 'PH-AI';
        const { loginIdentity } = this.$store.getters.userInfo
        // 如果是PH-AI版本，强制使用分销商身份；否则保持原身份
        const finallyLoginIdentity = isPHAI ? 2 : loginIdentity;
        switch (Number(finallyLoginIdentity)) {
          case 0:
            if(share_location){
              autoJump(); //进入自动选择身份逻辑
            }else{
              this.$router.push({name: 'l_choose'});
            }
          break;
          case 1:
          bindRelationUrl ? this.checkBindRelationUrlJump(bindRelationUrl, finallyLoginIdentity) :
          this.$router.push("/");
          break;
          case 2:
          bindRelationUrl ? this.checkBindRelationUrlJump(bindRelationUrl, finallyLoginIdentity) :
          this.$router.push("/");
          break;
          default: this.$message.warning(`未知身份-${finallyLoginIdentity}`);
        }
        this.needValiCodePic = false;
        // 登录成功后，转到邀请分享的链接
        if(loginIdentity==1 || loginIdentity==2){
          if(share_location){
            location.href = location.origin + JSON.parse(share_location);
          }
        }

      } else {
        this.$message.error('获取用户信息失败')
      }
    },
    async getValiCodePic() {
      try {
        const src = await getValiCodePicSrc()
        if (!src) return ;
        this.byteImg = src
      } catch (error) {
        console.log(error)
      }
    },
    // 登录接口返回状态为login_verify_random需要填写手机验证码
    loginVerifyFlow({companyId, accountId, msg, _code}) {
      this.phoneVerifyCodeParams = {companyId, accountId}
      this.phoneVerifyCodePhoneNum = '';
      this.phoneVerifyCodeError = false;
      this.needPhoneVerifyCode = true;
      if (_code === -3) {
        this.phoneVerifyCodeError = true;
        this.phoneVerifyCodePhoneNum = '';
      } else {
        this.phoneVerifyCode = '';
        this.phoneVerifyCodeError = false;
        this.phoneCodeMsg = msg || '请输入验证码'
      }
    },
    async getPhoneLoginVerifyCode() {
      const { phone } = this.form;
      if (!regPhone.test(phone)) return false;
      this.setupPhoneVerifyCodeCD();
      try {
        let res = await phoneLoginCodeGet({ phone });
        const { result, message } = res.data;
        if (result === 3) {
          this.$message.warning(message);
          this.clearPhoneVerifyCodeCD()
          return false;
        }
        if (result !== 1) {
          this.clearPhoneVerifyCodeCD()
        }
      } catch (error) {
        this.clearPhoneVerifyCodeCD()
      }
    },
    async getPhoneVerifyCode() {
      this.setupPhoneVerifyCodeCD();
      let res = await phoneCodeGet(this.phoneVerifyCodeParams);

      if (!res) {
        this.phoneVerifyCodePhoneNum = ''
      } else {
        
        if (res.data.status === 'success') {
          this.phoneVerifyCodePhoneNum = res.data.phoneNum;
        } else {
          this.phoneVerifyCodeError = true
          this.errorMsg = res.data.message || '获取验证码失败，请稍后重试'
        }
      }
    },
    setupPhoneVerifyCodeCD() {
      this.getPhoneVerifyCodeTimmer = setInterval(() => {
        if (this.getPhoneVerifyCodeCD < 1) {
          this.clearPhoneVerifyCodeCD()
        } else {
          this.getPhoneVerifyCodeCD -= 1
        }
      }, 1000);
    },
    clearPhoneVerifyCodeCD() {
      this.getPhoneVerifyCodeTimmer && clearInterval(this.getPhoneVerifyCodeTimmer)
      this.getPhoneVerifyCodeTimmer = null;
      this.$nextTick(() => {
        this.getPhoneVerifyCodeCD = 60
      })
    },
    clearPhoneCode() {
      this.clearPhoneVerifyCodeCD()
      this.needPhoneVerifyCode = false;
    },
    handleTabChange() {
      this.$refs.form.clearValidate();
      this.needPhoneVerifyCode = false;
      this.needValiCodePic = false;
    }
  },
  created() {
    const {companyName, userName, password} = this.$route.params
    const _form = {
      companyName: companyName || '',
      userName: userName || '',
      password: password || '',
    }
    this.form = _form
    this.$store.dispatch('clearShops');
    this.$change_color('#396CF3');
  },
  mounted(){
    // erp铺货页面，内嵌的是商品中心页面，这里抛个事件回去，通知loading关闭
    window.parent.postMessage({ eventName: 'unLoad' }, '*');
  },
  beforeDestroy() {
    this.clearPhoneVerifyCodeCD()
  }
}
</script>

<style lang="scss" scoped>
.login-tabs{
  min-height: 285px;
  margin-bottom: 16px;
  ::v-deep .el-tabs__header{
    margin: 0 0 24px 0;
  }
  ::v-deep .el-tabs__nav{
    width: 100%;
    .el-tabs__item{
      width: 50%;
      text-align: center;
      font-size: 16px;
      &:hover, &.is-active{
        color: #396CF3;
      }
    }
    .el-tabs__active-bar{
      background: #396CF3;
    }
  }
  ::v-deep .el-form-item{
    margin-bottom: 24px;
    &.mt-16 {
      margin-bottom: 16px;
    }
    .el-button{
      &:hover{
        color: #396CF3;
        border-color: #396CF3;
      }
    }
  }
}

.footer {
  text-align: center;
  color: #6C6C6C;
  font-size: 14px;
  margin-bottom: 40px;
  height: 22px;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
  ::v-deep .el-button--link{
    padding: 0;
    color: #396CF3;
    & > span:hover:after{
      border-bottom: 1px solid #396CF3;
    }
  }
}
.phoneCodeMsg {
  padding: 10px 0;
  color: red;
  border-top: 1px solid #ccc;
}
.valicode-row {
  display: flex;
  align-items: center;
  font-size: 12px;
  .link {
    padding: 0;
    color: #396CF3;
  }

  .valicode-input {
    width: 110px;
    margin-right: 8px;
  }
  .valicode-pic {
    margin-right: 8px;
    width: 121px;
    height: 40px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .valicode-msg-input {
    width: 239px;
    margin-right: 10px;
  }
  .valicode-msg-btn {
    padding: 0 18px;
    height: 40px;
    border-radius: 4px;
  }
}
.phoneCodeTip {
  color: #4b8b38;
  margin-top:-10px;
  margin-bottom: 20px;
}
.phoneCodeTipError {
  color: red;
  margin-top:-10px;
  margin-bottom: 20px;
}

</style>
